import React, { useEffect } from "react";
import ExitIntentPopup from "../ExitIntentPopup/index";
import AssignmentBar from "../AssignmentBar/index";
import { usePopupAssignment } from "../PopupAssignmentContext/index";

const PopupAssignmentManager = () => {
  const {
    showPopup,
    setShowPopup,
    showAssignmentBar,
    setShowAssignmentBar,
    popupDismissed,
    handlePopupClose,
    handleAssignmentBarClose,
  } = usePopupAssignment();

  // Check current page
  const isOktoberfestPage =
    typeof window !== "undefined" &&
    window.location.pathname === "/oktoberfest";

  useEffect(() => {
    // Check session storage for dismissed states
    const popupDismissedSession = sessionStorage.getItem("oktoberfest-popup-dismissed");
    const assignmentDismissedSession = sessionStorage.getItem(
      "oktoberfest-assignment-dismissed"
    );
    const visitedOktoberfest = sessionStorage.getItem("visited-oktoberfest");

    if (isOktoberfestPage) {
      // Mark that user visited Oktoberfest page
      sessionStorage.setItem("visited-oktoberfest", "true");
      
      // On Oktoberfest page: Never show popup
      setShowPopup(false);
      
      // Never show assignment bar on Oktoberfest page
      setShowAssignmentBar(false);

    } else {
      // On other pages (not Oktoberfest)
      
      // If assignment bar was manually dismissed, don't show it
      if (assignmentDismissedSession === "true") {
        setShowAssignmentBar(false);
        return;
      }

      // If popup was dismissed, show assignment bar on all pages except Oktoberfest
      if (popupDismissedSession === "true") {
        setShowAssignmentBar(true);
      }

      // Popup will be triggered by ExitIntentPopup component's internal logic
    }
  }, [
    isOktoberfestPage,
    showAssignmentBar,
    setShowAssignmentBar,
    setShowPopup,
    handleAssignmentBarClose,
  ]);

  return (
    <>
      {/* Show popup on all pages except Oktoberfest */}
      {!isOktoberfestPage && (
        <ExitIntentPopup
          onClose={handlePopupClose}
          onAssignmentBarShow={() => {
            // This will be handled by the context when popup closes
          }}
        />
      )}
      
      {/* Show assignment bar on all pages if visible */}
      <AssignmentBar
        isVisible={showAssignmentBar}
        onClose={handleAssignmentBarClose}
      />
    </>
  );
};

export default PopupAssignmentManager;
